import { gql } from 'apollo-angular';
import { CommandTemplate } from '../../entities/commandTemplate/commandTemplate';

export const EXECUTE_COMMAND_MUTATION = gql`
mutation executeCommand($commandInput: CommandInput) {
  executeCommand(commandInput: $commandInput)
}
`;

export const GET_COMMAND_BY_COMMAND_INPUT_QUERY = gql`
query getCommandByCommandInput($commandInput: CommandInput) {
  getCommandByCommandInput(commandInput: $commandInput)
}`;

export interface getCommandByCommandInputResponse {
  loading: boolean;
  commandTemplate: CommandTemplate
}
